import * as React from 'react';
import { FC } from 'react';

import { LoyaltyBanner } from 'pages/loyalty/loyalty-banner';
import { isMobile } from 'utils/environment';

import { LoyaltyCtaBar } from '../loyalty-cta-bar';
import LoyaltyFeaturedRewards from '../loyalty-featured-rewards/loyalty-featured-rewards';

import { LoyaltyRewardsViewBase } from './loyalty-rewards.view.base';
import { ILoyaltyRewardsViewProps } from './types';

export const LoyaltyRewardsView: FC<ILoyaltyRewardsViewProps> = props => {
  const { selectedReward } = props;
  return (
    <>
      <LoyaltyCtaBar />
      {!props.selectedReward && <LoyaltyBanner />}
      {isMobile() && !selectedReward && <LoyaltyFeaturedRewards />}
      <LoyaltyRewardsViewBase {...props} />
    </>
  );
};
